import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'centerCap',
  title: 'Center Caps',
  type: 'document',
  orderings: [
    {
      title: 'Name A-Z',
      name: 'nameAsc',
      by: [{field: 'name', direction: 'asc'}],
    },
  ],
  fields: [
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      validation: (rule: any) => rule.required(),
    }),
  ],
})